module.exports = __webpack_public_path__ + "static/lifeline-159ff7516ec640d7dc8e3bd82c7cb828.png";